import {Component, ElementRef, OnInit, ViewChild} from '@angular/core'
import {CommonModule} from '@angular/common'
import {ButtonModule} from "primeng/button"
import {MapService} from "../../../../services/src/lib/map.service"
import {MapType} from "../../../../domain/src/lib/map.model"
import {DynamicDialogConfig, DynamicDialogRef} from "primeng/dynamicdialog"
import {DialogModule} from "primeng/dialog"
import {CardModule} from "primeng/card"


@Component({
  selector: 'map-route',
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    DialogModule,
    CardModule,
  ],
  templateUrl: './map.component.html',
  styleUrl: './map.component.sass',
})
export class MapComponent implements OnInit {
  @ViewChild('map', {static: true}) mapContainer!: ElementRef
  // private mapType = MapType.PLACES
  mapType = MapType.ROUTES
  departureAddress = "strasse 1, location1"
  arrivalAddress = "strasse 2, location2"


  constructor(
      private readonly mapSvc: MapService,
      private readonly ref: DynamicDialogRef,
      private readonly config: DynamicDialogConfig,
  ) {
  }


  ngOnInit() {
    this.config.data.htmlRef = this.mapContainer
    this.mapSvc.initMap(this.mapType, this.config.data)
  }


  handleCloseDialog() {
    this.ref.close()
  }
}
